import React from 'react';
const AddressIcon = () => {
    return ( 
        <div className="icon-svg">
            <svg xmlns="http://www.w3.org/2000/svg" width="43.265" height="46.711"
                viewBox="0 0 43.265 46.711">
                <g id="Group_10856" data-name="Group 10856" transform="translate(-144.754 15.757)">
                    <path id="Path_20196" data-name="Path 20196"
                        d="M49.038,38.64a.392.392,0,0,0-.432-.384H45.729c-.192-2.542-1.87-4.556-3.933-4.556s-3.741,2.062-3.933,4.6H34.987a.461.461,0,0,0-.432.384L33.5,53.075a.889.889,0,0,0,.1.336.415.415,0,0,0,.288.144h15.97a.342.342,0,0,0,.288-.144.4.4,0,0,0,.1-.336ZM41.8,34.8c1.439,0,2.686,1.439,2.877,3.405H38.919C39.111,36.242,40.358,34.8,41.8,34.8Zm-2.877,7.146a.719.719,0,1,1,.719-.719A.706.706,0,0,1,38.919,41.949Zm5.659,0a.719.719,0,1,1,.719-.719A.706.706,0,0,1,44.578,41.949Z"
                        transform="translate(124.926 -34.062)" fill="#0087c3" />
                    <path id="Path_20197" data-name="Path 20197"
                        d="M80.834,69.4a2.734,2.734,0,1,0,2.734,2.734A2.764,2.764,0,0,0,80.834,69.4Z"
                        transform="translate(101.715 -52.642)" fill="#0087c3" />
                    <path id="Path_20198" data-name="Path 20198"
                        d="M80.961,82.9H75.4A2.457,2.457,0,0,0,73,85.394v2.35H83.359v-2.35A2.489,2.489,0,0,0,80.961,82.9Z"
                        transform="translate(104.369 -59.667)" fill="#0087c3" />
                    <path id="Path_20199" data-name="Path 20199"
                        d="M47.734,1.6A2.764,2.764,0,0,0,45,4.334a2.734,2.734,0,0,0,5.467,0A2.732,2.732,0,0,0,47.734,1.6Z"
                        transform="translate(118.941 -17.357)" fill="#0087c3" />
                    <path id="Path_20200" data-name="Path 20200"
                        d="M47.861,15.1H42.3a2.457,2.457,0,0,0-2.4,2.494v2.35H50.259v-2.35A2.427,2.427,0,0,0,47.861,15.1Z"
                        transform="translate(121.595 -24.383)" fill="#0087c3" />
                    <path id="Path_20201" data-name="Path 20201"
                        d="M14.334,69.4a2.734,2.734,0,1,0,0,5.467,2.764,2.764,0,0,0,2.734-2.734A2.732,2.732,0,0,0,14.334,69.4Z"
                        transform="translate(136.323 -52.642)" fill="#0087c3" />
                    <path id="Path_20202" data-name="Path 20202"
                        d="M14.409,83H8.8a2.469,2.469,0,0,0-2.4,2.542v2.35H16.855v-2.35A2.509,2.509,0,0,0,14.409,83Z"
                        transform="translate(139.029 -59.719)" fill="#0087c3" />
                    <path id="Path_20203" data-name="Path 20203"
                        d="M78.141,32.863a20.315,20.315,0,0,1-.863,6.187l1.535,1.487a20.662,20.662,0,0,0,1.295-7.673A21.415,21.415,0,0,0,66.2,13.2l.048,2.062A19.435,19.435,0,0,1,78.141,32.863Z"
                        transform="translate(107.908 -23.394)" fill="#0087c3" />
                    <path id="Path_20204" data-name="Path 20204"
                        d="M6.914,32.863a21.931,21.931,0,0,0,.911,6.187L6.291,40.536A20.662,20.662,0,0,1,5,32.863,21.415,21.415,0,0,1,18.9,13.2l-.048,2.062A19.479,19.479,0,0,0,6.914,32.863Z"
                        transform="translate(139.762 -23.394)" fill="#0087c3" />
                    <path id="Path_20205" data-name="Path 20205"
                        d="M48.662,91.8a19.165,19.165,0,0,1-7.625,1.535,20.482,20.482,0,0,1-7.1-1.295L32.5,93.479a21.252,21.252,0,0,0,8.536,1.774,20.886,20.886,0,0,0,9.016-2.014Z"
                        transform="translate(125.446 -64.299)" fill="#0087c3" />
                </g>
            </svg>

        </div>
     );
}
 
export default AddressIcon;